import { render, staticRenderFns } from "./StudentOvertakeClassCoordinator.vue?vue&type=template&id=60715115"
import script from "./StudentOvertakeClassCoordinator.vue?vue&type=script&lang=js"
export * from "./StudentOvertakeClassCoordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports